import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { postChatInfo, resetStore as resetChatStore } from "../chat/actions";
import { isNull } from "../../packages/helpers/predicates";
import { selectNotProvidedChatId } from "../chat/selectors";
import { CHAT_STATE } from "./constants";
import { Context } from "./context";
import { isChatOpen } from "./predicates";
import type { ProviderProps } from "./types";

const switcher = (state: CHAT_STATE) =>
  !isChatOpen(state) ? CHAT_STATE.OPEN : CHAT_STATE.HIDE;

export const ControlProvider = ({ children, config }: ProviderProps) => {
  const [chatState, setChatState] = useState(CHAT_STATE.START);
  const chatId = useAppSelector(selectNotProvidedChatId);
  const handleChatOpen = () => setChatState(switcher);

  const handleChatHide = () => setChatState(CHAT_STATE.HIDE);
  const dispatch = useAppDispatch();

  const api = {
    authApi: config.api.postUser,
    getChatInfoApi: config.api.getChatInfo,
    getChatSettingsApi: config.api.getChatSettings,
    postChatInfo: config.api.postChatInfo,
    getMessagesApi: config.api.getMessages,
    postMessageTextApi: config.api.postMessage,
    postMessageFileApi: config.api.postMessageFile,
    postEventApi: config.api.postEvent,
    getFileApi: config.api.getFile,
  };

  useEffect(() => {
    // если чат открылся а id === null то отправляем запрос на регистрацию чата
    if (isChatOpen(chatState) && isNull(chatId)) {
      const params = {
        postChatInfoApi: api.postChatInfo,
      };

      dispatch(postChatInfo(params));
    }
  }, [chatState]);

  const { sse, feature } = config;

  return (
    <Context.Provider
      value={{
        api,
        sse,
        feature,
        chatState,
        handleChatOpen,
        handleChatHide,
      }}
    >
      {children}
    </Context.Provider>
  );
};
